import { Button, Dialog, DialogContent } from '@mui/material'
import React from 'react'

export default function ConfirmDialogPlandistribution({ open, setOpen, rows, handleAdd, isLoading }) {
    function getTotal(plan) {
        let total = 0;
        total = +(plan?.TargetMonth_1 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_2 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_3 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_4 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_5 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_6 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_7 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_8 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_9 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_10 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_11 || 0).toString().replaceAll(',', '') +
            +(plan?.TargetMonth_12 || 0).toString().replaceAll(',', '');
        return total;
    }
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการแผนการจำหน่าย {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless table-hover ">
                            <thead>

                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center">พันธุ์ข้าว</th>
                                    <th scope="col " class="text-center">ต.ค.</th>
                                    <th scope="col " class="text-center">พ.ย.</th>
                                    <th scope="col " class="text-center">ธ.ค.</th>
                                    <th scope="col " class="text-center">ม.ค.</th>
                                    <th scope="col " class="text-center">ก.พ.</th>
                                    <th scope="col " class="text-center">มี.ค.</th>
                                    <th scope="col " class="text-center">เม.ย.</th>
                                    <th scope="col " class="text-center">พ.ค.</th>
                                    <th scope="col " class="text-center">มิ.ย.</th>
                                    <th scope="col " class="text-center">ก.ค.</th>
                                    <th scope="col " class="text-center">ส.ค.</th>
                                    <th scope="col " class="text-center">ก.ย.</th>
                                    <th scope="col " class="text-center">รวม</th>
                                    <th scope="col " class="text-center">หน่วย</th>

                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((b, i) =>
                                    <tr>
                                        <td class="text-center">{i + 1}</td>
                                        <td class="text-center">{b?.CatalogNo?.CatalogName}</td>
                                        <td class="text-center">{b?.TargetMonth_10 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_11 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_12 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_1 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_2 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_3 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_4 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_5 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_6 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_7 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_8 || 0}</td>
                                        <td class="text-center">{b?.TargetMonth_9 || 0}</td>
                                        <td class="text-center">{parseFloat(getTotal(b)).toFixed(2)
                                            .replace(/\d(?=(\d{3})+\.)/g, "$&,")}</td>
                                        <td class="text-center">กิโลกรัม</td>


                                    </tr>)}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">

                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={isLoading} onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
